import ComingSoon from '../../../../components/ComingSoon';
import DashboardLayout from '../../../../layouts/DashboardLayout';

const EmpAnalytics = () => {
  return (
    <DashboardLayout title="Analytics">
      <ComingSoon />
    </DashboardLayout>
  );
};

export default EmpAnalytics;
